// Setup Styles
import '../scss/style.scss';

// -- jQuery
var jQuery = require("jquery");
var $ = jQuery;
window.jQuery = window.$ = $;
require ('jquery-migrate')
require ('fitvids.1.1.0');
require ('flexslider')
require ('jquery-hoverintent');

// -- Bootstrap
//import * as bootstrap from 'bootstrap';
import 'bootstrap';

// -- Development Modules
import Logo from '../assets/bgsu-logo-rev.svg';
import Watermark from '../assets/bowling-green-state-university.svg';

if(process.env.NODE_ENV === 'development') {

	function updateLogos() {
	  const logos = document.querySelectorAll('.brand-logo');
	  
	  [].forEach.call(logos, function(logo) {
		if(window.console) console.log(logo);
		logo.src = Logo;
	  });
	}
	
	function updateWatermarks() {
	  const watermarks = document.querySelectorAll('.brand-watermark');
	  
	  [].forEach.call(watermarks, function(watermark) {
		watermark.src = Watermark;
	  });
	}
	
	updateLogos();
	updateWatermarks();
}

/* From https://codepen.io/gapcode/pen/vEJNZN - retrieved on February 24, 2017 */

/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
  var ua = window.navigator.userAgent;

  // Test values; Uncomment to check result …

  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

if (typeof CQ == 'undefined') {
	window.CQ = {
		shared: {
			"String": {
				/**
		         * Check to see if the the str starts with the prefix.
		         * The comparison is case sensitive.
		         * @static
		         * @param {String} str The string to check.
		         * @param {String} prefix The prefix to find.
		         * @return {Boolean} if the str starts with the prefix
		         * return true, otherwise false.
		         */
		        startsWith: function( str, prefix ) {
		            if (str == null || prefix == null) {
		                return str == null && prefix == null;
		            }
		
		            if (prefix.length > str.length) {
		                return false;
		            }
		
		            // ensure we are dealing with the string form of this object
		            var sMatch = str.toString();
		            var sSearch	= prefix.toString();
		
		            return (sMatch.indexOf(sSearch) == 0);
		        },
		
		        /**
		         * Check to see if the the str ends with the suffix.
		         * The comparison is case sensitive.
		         * @static
		         * @param {String} str The string to check.
		         * @param {String} suffix The suffix to find.
		         * @return {Boolean} if the str ends with the suffix
		         * return true, otherwise false.
		         */
		        endsWith: function( str, suffix ) {
		
		            if (str == null || suffix == null) {
		                return str == null && suffix == null;
		            }
		
		            if (suffix.length > str.length) {
		                return false;
		            }
		
		            // ensure we are dealing with the string form of this object
		            str = str.toString();
		            suffix	= suffix.toString();
		
		            return (str.lastIndexOf(suffix) == (str.length - suffix.length));
		        },
		
		        /**
		         * Check to see if the the str contains the searchStr.
		         * The comparison is case sensitive.
		         * @static
		         * @param {String} str The string to check.
		         * @param {String} searchStr The prefix to find.
		         * @return {Boolean} if the str ends with the suffix
		         * return true, otherwise false.
		         */
		        contains: function( str, searchStr ) {
		
		            if (str == null || searchStr == null) {
		                return false;
		            }
		
		            // ensure we are dealing with the string form of this object
		            str = str.toString();
		            searchStr = searchStr.toString();
		
		            return (str.indexOf(searchStr) >= 0);
		        }
			},
			"HTTP": {
				/**
		         * Returns the value of the cookie with the specified name.
		         * @static
		         * @param {String} name The name of the cookie
		         * @return {String} The value of the cookie
		         */
		        getCookie: function(name) {
		            var cname = encodeURIComponent(name) + "=";
		            var dc = document.cookie;
		            if (dc.length > 0) {
		                var begin = dc.indexOf(cname);
		                if (begin != -1) {
		                    begin += cname.length;
		                    var end = dc.indexOf(";", begin);
		                    if (end == -1) end = dc.length;
		                    return decodeURIComponent(dc.substring(begin, end));
		                }
		            }
		            return null;
		        },
		
		        /**
		         * Sets the value of the cookie with the specified name.
		         * @static
		         * @param {String} name The name of the cookie
		         * @param {String} value The value of the cookie
		         * @param {String} path (optional) The server path the cookie applies to
		         * @param {Number} days (optional) The number of days the cookie will live
		         * @param {String} domain (optional) The server domain
		         * @param {Boolean} secure (optional) True if the
		         *        connection is secure
		         * @return {String} The value of the cookie
		         */
		        setCookie: function(name, value, path, days, domain, secure) {
		            if (typeof(days) != "number") days = 7;
		            var date;
		            if (days > 0) {
		                date = new Date();
		                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		            } else {
		                date = new Date(0);
		            }
		            document.cookie = encodeURIComponent(name) + "=" +
		                    encodeURIComponent(value) + "; " +
		                    (days != 0 ? "expires=" + date.toGMTString() + "; " : "") +
		                    (domain ? "domain=" + domain + "; " : "") +
		                    (path ? "path=" + path : "") +
		                    (secure ? "; secure" : "");
		            return value;
		        },
		
		        /**
		         * Clears the cookie with the specified name.
		         * @static
		         * @param {String} name The name of the cookie
		         * @param {String} path (optional) The server path the cookie applies to
		         * @param {String} domain (optional) The server domain
		         * @param {Boolean} secure (optional) True if the
		         *        connection is secure
		         */
		        clearCookie : function(name, path, domain, secure) {
		            window.CQ.shared.HTTP.setCookie(name, "null", path || "", -1, domain || "", secure || "");
		        }
			}
		}
	};
}
if(typeof CQ_Analytics == 'undefined') {
	window.CQ_Analytics = {
		TestTarget: {
			defaults: {},
			triggerUpdate: function() {
				if(window.console) console.info('CQ_Analytics.TestTarget called');
			},
			ignoreLateMboxArrival: function(mboxId, mboxName, time) {
				if(window.console) console.info('Targeted Component: #'+mboxId+'[name='+mboxName+'], Delay: '+time);
			}
		}
	};
}
(function(f) {
    var g;
    if (typeof window !== "undefined") {
        g = window;
    } else if (typeof global !== "undefined") {
        g = global;
    } else if (typeof self !== "undefined") {
        g = self;
    } else {
        g = this;
    }
    g.BGSU = f();
})(function () {
	
	var VERSION = '1.0.0'
		
	var CONSTANTS = {};
	
	/**
	  * Mark any object with an incrementing number
	  * used for keeping track of objects
	  *
	  * @param Object obj   Any object or DOM Element
	  * @param String key
	  * @return Object
	  */
	  var _stamp = (function () {
	    var keys = {};
	    return function stamp (obj, key) {

	      // get group key
	      key = key || 'introjs-stamp';

	      // each group increments from 0
	      keys[key] = keys[key] || 0;

	      // stamp only once per object
	      if (obj[key] === undefined) {
	        // increment key for each new object
	        obj[key] = keys[key]++;
	      }

	      return obj[key];
	    };
	  })();
	
	function _Prototype_Add(name, fnc) {
		this[name] = BGSU.prototype[name] = fnc;
	}
	
	function BGSU() {
	}
	
	var bgsu = function(obj) {

		var instance;

		if (typeof (obj) === 'object') {
	      // create a new instance
	      instance = new BGSU(obj);

	    } else {

	      // use defaults
	      instance = new BGSU();
	    }

	    // add instance to list of _instances
	    // passing group to _stamp to increment
	    // from 0 onward somewhat reliably
	    bgsu.instances[ _stamp(instance, 'bgsu-instance') ] = instance;

		return instance;

	};
	
	bgsu.version = VERSION;
	bgsu.consts = CONSTANTS;

	bgsu.instances = {};
	
	bgsu.fn = BGSU.prototype = {
		add: function(name, fnc){
			_Prototype_Add.call(this, name, fnc);
		}
	}
	
	return bgsu;
});
(function(f) {
	var g;
    if (typeof window !== "undefined") {
        g = window;
    } else if (typeof global !== "undefined") {
        g = global;
    } else if (typeof self !== "undefined") {
        g = self;
    } else {
        g = this;
    }
    g.BGSU().add('CrossSiteCookie',f());
})(function () {

	var VERSION = '1.0.0';
	
	var CONSTANTS = {
		productionHosts: ["www.bgsu.edu", "www.firelands.bgsu.edu", "webapp.bgsu.edu", "services.bgsu.edu"],
		testHosts: ["wwwtest.bgsu.edu", "wwwtest.firelands.bgsu.edu", "webapptest.bgsu.edu", "servicestest.bgsu.edu"],
		domainPrefix: "bgsu.edu"
	};
	
	/**
	  * Mark any object with an incrementing number
	  * used for keeping track of objects
	  *
	  * @param Object obj   Any object or DOM Element
	  * @param String key
	  * @return Object
	  */
	  var _stamp = (function () {
	    var keys = {};
	    return function stamp (obj, key) {

	      // get group key
	      key = key || 'introjs-stamp';

	      // each group increments from 0
	      keys[key] = keys[key] || 0;

	      // stamp only once per object
	      if (obj[key] === undefined) {
	        // increment key for each new object
	        obj[key] = keys[key]++;
	      }

	      return obj[key];
	    };
	  })();
	
	function _IsOn() {
		return ($("body").hasClass(this._settings.className__body));
	}

	function _TurnOn() {
		$("body").addClass(this._settings.className__body);
		_SetCookie.call(this);
		if(typeof this._settings.action__Activate === 'function') this._settings.action__Activate();
	}

	function _TurnOff() {
		if(window.console) console.log("TURNING OFF");
		$("body").removeClass(this._settings.className__body);
		_RemoveCookie.call(this);
		if(typeof this._settings.action__Deactivate === 'function') this._settings.action__Deactivate();
		if(window.console) console.log("TURNED OFF");
	}
	
	
	function _IsHostWwwProd() {
		return window.location.hostname && CONSTANTS.productionHosts.indexOf(window.location.hostname) > -1;
	}

	function _IsHostWwwTest() {
		return window.location.hostname && CONSTANTS.testHosts.indexOf(window.location.hostname) > -1;
	}

	function _IsHostBgsu() {
		return window.location.hostname && CQ.shared.String.endsWith(window.location.hostname, "."+CONSTANTS.domainPrefix);
	}

	function _SetCookie() {
		if (_IsHostBgsu.call(this)) {
			var cookie = _GetCookie.call(this);
			var hosts = [];
			if (typeof cookie !== "undefined" && cookie != null && typeof cookie == "string") {
				hosts = cookie.split(";");
			}
			if (_IsHostWwwProd.call(this)) {
				for (var i = 0; i < CONSTANTS.productionHosts.length; i++) {
					var productionHost = CONSTANTS.productionHosts[i];
					if (hosts.indexOf(productionHost) == -1) {
						hosts.push(productionHost);
					}
				}
			}
			else if (_IsHostWwwTest()) {
				for (var i = 0; i < CONSTANTS.testHosts.length; i++) {
					var testHost = CONSTANTS.testHosts[i];
					if (hosts.indexOf(testHost) == -1) {
						hosts.push(testHost);
					}
				}
			}
			else {
				if (hosts.indexOf(window.location.hostname) == -1) {
					hosts.push(window.location.hostname);
				}
			}
			if(window.console) console.log(hosts.join(";"));
			CQ.shared.HTTP.setCookie(this._settings.cookieName, hosts.join(";"), "/", 999, CONSTANTS.domainPrefix, CQ.shared.HTTP.COOKIE_SECURE);
		}
		else {
			if(window.console) console.log("Probably localhost");
			CQ.shared.HTTP.setCookie(this._settings.cookieName, window.location.hostname, "/", 999, window.location.hostname);
		}
	}

	function _RemoveCookie() {
		if (_IsHostBgsu.call(this)) {
			var cookie = _GetCookie.call(this);
			var hosts = [];
			if (typeof cookie !== "undefined" && cookie != null && typeof cookie == "string") {
				var hosts = cookie.split(";");
				if (_IsHostWwwProd.call(this)) {
					hosts = hosts.filter(function(element, index, array) {
						return CONSTANTS.productionHosts.indexOf(element) == -1;
					}, this);
				}
				else if (_IsHostWwwTest.call(this)) {
					hosts = hosts.filter(function(element, index, array) {
						return CONSTANTS.testHosts.indexOf(element) == -1;
					}, this);
				}
				else {
					hosts = hosts.filter(function(element, index, array) {
						return element != window.location.hostname;
					}, this);
				}
			}
			if (hosts.length > 0) {
				CQ.shared.HTTP.setCookie(this._settings.cookieName, hosts.join(";"), "/", 0, CONSTANTS.domainPrefix);
			}
			else {
				CQ.shared.HTTP.clearCookie(this._settings.cookieName, "/", CONSTANTS.domainPrefix);
			}
		}
		else {
			CQ.shared.HTTP.clearCookie(this._settings.cookieName, "/", window.location.hostname);
		}
	}

	function _GetCookie() {
		return CQ.shared.HTTP.getCookie(this._settings.cookieName);
	}

	function _HasCookie() {
		var cookie = _GetCookie.call(this);
		if (typeof cookie !== "undefined" && cookie != null && typeof cookie == "string") {
			if(window.console) console.log("COOKIE FOUND");
			var hosts = cookie.split(";");
			return (hosts.indexOf(window.location.hostname) > -1);
		}
		if(window.console) console.log("COOKIE NOT FOUND");
		return false;
	}

	function _SetAction(actionOn) {
		if (actionOn == null) actionOn = !_IsOn.call(this);
		
		if (actionOn) {
			if(window.console) console.log("Add Class");
			_TurnOn.call(this);
		}
		else {
			if(window.console) console.log("Remove Class");
			_TurnOff.call(this);
		}
		
	}
	
	function CrossSiteCookie(settings) {
		
		if(window.console) console.log(settings);
		
		this._settings = {
			className__body: null,
			className__buttonToggle: null,
			className__buttonOn: null,
			className__buttonOff: null,
			cookieName: null,
			action__Activate: null,
			action__Deactivate: null
		};
		
		if (typeof settings !== "undefined" && settings != null) {
			for(var selector in settings) {
				if(typeof selector === 'string' && this._settings.hasOwnProperty(selector) )
					this._settings[selector] = settings[selector];
			}
		}
		
		if(window.console) console.log(this._settings);
		
		if (_HasCookie.call(this)) {
			if(window.console) console.log("Has Cookie");
			_TurnOn.call(this);
		}
		else {
			if(window.console) console.log("No Cookie");
			_TurnOff.call(this);
		}

		if (typeof this._settings.className__buttonToggle !== "undefined" && this._settings.className__buttonToggle != null) {
			$(this._settings.className__buttonToggle).on("click", null, { self: this }, function(event) {
				event.preventDefault();
				event.data.self.toggle();
			});
		}
		if (typeof this._settings.className__buttonOn !== "undefined" && this._settings.className__buttonOn != null) {
			$(this._settings.className__buttonOn).on("click", null, { self: this }, function(event) {
				event.preventDefault();
				event.data.self.set(true);
			});
		}
		if (typeof this._settings.className__buttonOff !== "undefined" && this._settings.className__buttonOff != null) {
			$(this._settings.className__buttonOff).on("click", null, { self: this }, function(event) {
				event.preventDefault();
				event.data.self.set(false);
			});
		}
		
		return this;
		
	}
	
	var crossSiteCookie = function(settings) {
		
		var instance;

		if (typeof (settings) === 'object') {
			
	      // create a new instance
	      instance = new CrossSiteCookie(settings);

	    } else {
	    	
	      // use defaults
	      instance = new CrossSiteCookie();
	      
	    }

	    // add instance to list of _instances
	    // passing group to _stamp to increment
	    // from 0 onward somewhat reliably
	    crossSiteCookie.instances[ _stamp(instance, 'crossSiteCookie-instance') ] = instance;

		return instance;
		
	};
	
	crossSiteCookie.version = VERSION;
	crossSiteCookie.consts = CONSTANTS;

	crossSiteCookie.instances = {};
	
	crossSiteCookie.fn = CrossSiteCookie.prototype = {
		set: function(boolean) {
			_SetAction.call(this, boolean);
		},
		toggle: function() {
			_SetAction.call(this);
		}
	}

	return crossSiteCookie;
});
$(function(){
	var className = '.cmp-cookie-stmt';
	
	//if(window.console) console.log(className);
	
	function _CookieActive() {
		$(className).removeClass('show');
		$(className).addClass('hide');
	}
	
	function _CookieInactive() {
		$(className).removeClass('hide');
		$(className).addClass('show');
	}
	
	BGSU().CrossSiteCookie({
		className__body: "action__statement-accepted",
		className__buttonOn: ".cmp-cookie-stmt__accept-action",
		cookieName: "cookie_statement",
		action__Activate: function(){
			if(window.console) console.log("activate");
			_CookieActive();
		},
		action__Deactivate: function() {
			if(window.console) console.log("deactivate");
			_CookieInactive();
		}
	});
});
function _adjustChatWithItsContainers() {

	window.bgsuAdjustChatWithItsContainersAttempts++;
	if (window.bgsuAdjustChatWithItsContainersAttempts > 50) {
		clearInterval(window.bgsuAdjustChatWithItsContainersId);
		return;
	}

	var containerFound = false;
	var containerChanged = false;
	$("div.ivy-main").each(function(index) {
		containerFound = true;
		var role = $(this).attr("role");
		if (typeof role === "undefined") {
			$(this).attr("role", "complementary");
			$(this).attr("aria-label", "Chat with ITS");
			containerChanged = true;
		}
	});

	if (containerFound && !containerChanged) {
		clearInterval(window.bgsuAdjustChatWithItsContainersId);
	}
	
}

function adjustChatWithItsContainers() {

	if (typeof window.bgsuAdjustChatWithItsContainersId === "undefined" || window.bgsuAdjustChatWithItsContainersId == null) {
		window.bgsuAdjustChatWithItsContainersAttempts = 0;
		window.bgsuAdjustChatWithItsContainersId = setInterval(_adjustChatWithItsContainers, 125);
	}

}

function adjustChatWithItsControls() {

	adjustChatWithItsContainers();

}

function cleanWhitespaceOnlyTextElements() {

	/*
		Find all textual elements that have no children and contain only
		whitespace.  Trim the content in those elements so that they can
		be picked up by the :empty selector.  It is assumed there is a
		corresponding style rule that hides empty elements (ex. h4:empty).
	 */

	var elements = $("p,h1,h2,h3,h4,h5,h6");
	
	$(elements).each(function(index, element) {

		var children = $(element).children();
		if (children && children.length == 0) {
			var text = $(element).text();
			if (text && text.trim().length == 0) {
				$(element).text("");
			}
		}

	});

}

//if (typeof BGSUContrast == "undefined") {

	var BGSUContrast = BGSUContrast || {};

	BGSUContrast = {

		className: "acc-contrast",
		cookieName: "acc-contrast",
		productionHosts: ["www.bgsu.edu", "www.firelands.bgsu.edu", "webapp.bgsu.edu", "services.bgsu.edu"],
		testHosts: ["wwwtest.bgsu.edu", "wwwtest.firelands.bgsu.edu", "webapptest.bgsu.edu", "servicestest.bgsu.edu"],

		isContrastOn: function() {
			return ($("body").hasClass(this.className));
		},

		turnContrastOn: function() {
			if (!this.isContrastOn()) {
				$("body").addClass(this.className);
				this._applyContrastCookie();
			}
		},

		turnContrastOff: function() {
			if (this.isContrastOn()) {
				$("body").removeClass(this.className);
				this._removeContrastCookie();
			}
		},

		setContrast: function(contrastOn) {
			if (contrastOn) {
				this.turnContrastOn();
			}
			else {
				this.turnContrastOff();
			}
		},

		toggleContrastSwitch: function() {
			if (this.isContrastOn()) {
				this.turnContrastOff();
			}
			else {
				this.turnContrastOn();
			}
		},

		initialize: function(contrastControlSelectors) {

			if (this._hasContrastCookie()) {
				this.turnContrastOn();
			}
			else {
				this.turnContrastOff();
			}

			if (typeof contrastControlSelectors !== "undefined" && contrastControlSelectors != null) {
				if (typeof contrastControlSelectors.toggle !== "undefined" && contrastControlSelectors.toggle != null) {
					$(contrastControlSelectors.toggle).on("click", null, { self: this }, function(event) {
						event.data.self.toggleContrastSwitch();
					});
				}
				if (typeof contrastControlSelectors.contrastOn !== "undefined" && contrastControlSelectors.contrastOn != null) {
					$(contrastControlSelectors.contrastOn).on("click", null, { self: this }, function(event) {
						event.data.self.setContrast(true);
					});
				}
				if (typeof contrastControlSelectors.contrastOff !== "undefined" && contrastControlSelectors.contrastOff != null) {
					$(contrastControlSelectors.contrastOff).on("click", null, { self: this }, function(event) {
						event.data.self.setContrast(false);
					});
				}
			}

		},

		/*
			If the user toggles contrast for the main campus site, this needs to apply to the Firelands campus site, and vice versa.
			The sites for the two campuses have different domains so the cookie cannot be applied to a specific domain.
			To work around this, maintain only one cookie for the domain "bgsu.edu" that has a value containing all the hosts to
			which the contrast setting applies.  For example, if the user turns contrast on while on www.bgsu.edu, the cookie will
			have the "www.bgsu.edu" and "www.firelands.bgsu.edu" appended to the cookie's value.

			In addition, the contrast needs to apply to the correct production or test environment.  For instance, if the user activates
			contrast on "www.bgsu.edu" then it should also be activated on "webapp.bgsu.edu" and "services.bgsu.edu".

			Rules:
			- If setting contrast on www.bgsu.edu, www.firelands.bgsu.edu, webapp.bgsu.edu, or services.bgsu.edu
			  then apply to all of these with a domain of "bgsu.edu".
			- If setting contrast on wwwtest.bgsu.edu, wwwtest.firelands.bgsu.edu, webapptest.bgsu.edu, or servicestest.bgsu.edu
			  then apply to all of these with a domain of "bgsu.edu".
			- If setting contrast on any other bgsu.edu subdomain (aem[test].bgsu.edu), apply just that subdomain to the cookie value with a domain of "bgsu.edu".
			- If setting contrast on anything else (localhost), use that as the domain and assign a dummy value to the cookie.
		 */

		_isHostWwwProd: function() {
			return window.location.hostname && this.productionHosts.indexOf(window.location.hostname) > -1;
		},

		_isHostWwwTest: function() {
			return window.location.hostname && this.testHosts.indexOf(window.location.hostname) > -1;
		},

		_isHostBgsu: function() {
			return window.location.hostname && CQ.shared.String.endsWith(window.location.hostname, ".bgsu.edu");
		},

		_applyContrastCookie: function() {
			if (this._isHostBgsu()) {
				var contrastCookie = this._getContrastCookie();
				var hosts = [];
				if (typeof contrastCookie !== "undefined" && contrastCookie != null && typeof contrastCookie == "string") {
					hosts = contrastCookie.split(";");
				}
				if (this._isHostWwwProd()) {
					for (var i = 0; i < this.productionHosts.length; i++) {
						productionHost = this.productionHosts[i];
						if (hosts.indexOf(productionHost) == -1) {
							hosts.push(productionHost);
						}
					}
				}
				else if (this._isHostWwwTest()) {
					for (var i = 0; i < this.testHosts.length; i++) {
						testHost = this.testHosts[i];
						if (hosts.indexOf(testHost) == -1) {
							hosts.push(testHost);
						}
					}
				}
				else {
					if (hosts.indexOf(window.location.hostname) == -1) {
						hosts.push(window.location.hostname);
					}
				}
				CQ.shared.HTTP.setCookie(this.cookieName, hosts.join(";"), "/", 0, "bgsu.edu");
			}
			else {
				CQ.shared.HTTP.setCookie(this.cookieName, window.location.hostname, "/", 0, window.location.hostname);
			}
		},

		_removeContrastCookie: function() {
			if (this._isHostBgsu()) {
				var contrastCookie = this._getContrastCookie();
				var hosts = [];
				if (typeof contrastCookie !== "undefined" && contrastCookie != null && typeof contrastCookie == "string") {
					var hosts = contrastCookie.split(";");
					if (this._isHostWwwProd()) {
						hosts = hosts.filter(function(element, index, array) {
							return this.productionHosts.indexOf(element) == -1;
						}, this);
					}
					else if (this._isHostWwwTest()) {
						hosts = hosts.filter(function(element, index, array) {
							return this.testHosts.indexOf(element) == -1;
						}, this);
					}
					else {
						hosts = hosts.filter(function(element, index, array) {
							return element != window.location.hostname;
						}, this);
					}
				}
				if (hosts.len > 0) {
					CQ.shared.HTTP.setCookie(this.cookieName, hosts.join(";"), "/", 0, "bgsu.edu");
				}
				else {
					CQ.shared.HTTP.clearCookie(this.cookieName, "/", "bgsu.edu");
				}
			}
			else {
				CQ.shared.HTTP.clearCookie(this.cookieName, "/", window.location.hostname);
			}
		},

		_getContrastCookie: function() {
			return CQ.shared.HTTP.getCookie(this.cookieName);
		},

		_hasContrastCookie: function() {
			var contrastCookie = this._getContrastCookie();
			if (typeof contrastCookie !== "undefined" && contrastCookie != null && typeof contrastCookie == "string") {
				var hosts = contrastCookie.split(";");
				return (hosts.indexOf(window.location.hostname) > -1);
			}
			return false;
		}

	};

	window.BGSUContrast = BGSUContrast;

//}

function makeImageBasedMenuItemsKeyboardNavigable() {

	$("li.dropdown ul.dropdown-menu").each(function(index) {
		var menuGroups = $(this).find("menu_group");
		if (menuGroups.length) {
			return;
		}
		var images = $(this).find("div.image.section");
		if (!images.length) {
			return;
		}
		$(images).each(function(index) {
			$(this).wrap("<div class=\"menu_group section\"><ol class=\"menu-group\"><li>");
			$(this).find("a").attr("role", "menuitem").attr("tabindex", "-1");
		});
	});

}

function makeLinksInTextComponentMenuItemsKeyboardNavigable() {

	$("li.dropdown ul.dropdown-menu").each(function(index) {
		var menuGroups = $(this).find("menu_group");
		if (menuGroups.length) {
			return;
		}
		var textComponents = $(this).find("div.text.parbase.section").has("a");
		if (!textComponents.length) {
			return;
		}
		$(textComponents).each(function(index) {
			$(this).wrap("<div class=\"menu_group section\"><ol class=\"menu-group\"><li>");
			$(this).find("a").attr("role", "menuitem").attr("tabindex", "-1");
		});
	});

}

function makeTopLevelMenuItemsClickable() {

	$(document).on("mousedown.dropdown.data-api", "li.dropdown > a[data-toggle=dropdown].disabled", function(event) {
		window.location = $(this).attr("href");
		return false;
	});

}

function makeTopLevelMenuItemsKeyboardNavigable() {

	$(document).on("keydown.dropdown.data-api", "li.dropdown > a[data-toggle=dropdown].disabled", function(event) {

		var parent = $(this).parent("li.dropdown");
		var menuEnclosure = parent.parent("ul");

		/* keyCode 40 == down arrow, 27 == Escape */

		if (!/(40|27)/.test(event.keyCode)) {
			menuEnclosure.children("li.dropdown").removeClass("open");
			return;
		}

		event.preventDefault();
		event.stopPropagation();
		
		if (event.keyCode == 27) {
			menuEnclosure.children("li.dropdown").removeClass("open");
			return;
		}
		
		var isActive = parent.hasClass("open");

		if (isActive) {
			var relatedMenu = parent.find("[role=menu]");
			if (relatedMenu.length) {
				relatedMenu.show();
			}
			var items = parent.find("[role=menu] li:not(.divider) a");
			if (items.length) {
				items.eq(0).trigger("focus");
			}
		}
		else {
			menuEnclosure.children("li.dropdown").removeClass("open");
			parent.addClass("open");
		}
	});

}

function enhanceMegaMenuNavigation() {

	makeImageBasedMenuItemsKeyboardNavigable();
	makeLinksInTextComponentMenuItemsKeyboardNavigable();
	makeTopLevelMenuItemsClickable();
	makeTopLevelMenuItemsKeyboardNavigable();

}

function replacePresentationAttributesInIframes(container) {

	/*
		With the advent of HTML5 several presentation attributes of iframe elements have
		become obsolete: allowtransparency, frameborder, hspace, marginheight, marginwidth,
		scrolling, and vspace (source: https://www.w3.org/TR/html5/obsolete.html).  It is
		preferable now to apply styles, but external libraries that create iframes may still
		use the presentation attributes.  Some of these attributes are flagged by accessibility
		tools as violating WCAG 2.0 Guideline 1.3.1 Info and Relationships.
		Replace these attributes where possible.

		Note that IE versions 9 and below do not support styling iframes using CSS.
	 */

	var ieVersion = detectIE();
	if (ieVersion !== false && ieVersion <= 9) {
		return;
	}

	var myContainer = (container ? container : $(document));

	var iframes = myContainer.find("iframe");

	replaceFrameborderAttributeInIframes(iframes);

	replaceScrollingAttributeInIframes(iframes);

}

function replaceFrameborderAttributeInIframes(iframes) {

	iframes.filter("[frameborder]").each(function(index) {
		var frameborder = $(this).attr("frameborder");
		var borderWidth = "medium";
		var borderStyle = (frameborder == 1 ? "solid" : "none");
		$(this).css("borderWidth", borderWidth);
		$(this).css("borderStyle", borderStyle);
		$(this).removeAttr("frameborder");
	});

}

function replaceScrollingAttributeInIframes(iframes) {

	var iframesScrollingAuto = iframes.filter("[scrolling=auto]");
	iframesScrollingAuto.css("overflow", "auto");
	iframesScrollingAuto.removeAttr("scrolling");

	var iframesScrollingYes = iframes.filter("[scrolling=yes]");
	iframesScrollingYes.css("overflow", "scroll");
	iframesScrollingYes.removeAttr("scrolling");

	/* Marketing & Communications requested that instances of scrolling="no" should no longer be replaced. */

}

function _adjustTwitterWidgetIframes() {

	window.bgsuAdjustTwitterWidgetIframesAttempts++;
	if (window.bgsuAdjustTwitterWidgetIframesAttempts > 50) {
		clearInterval(window.bgsuAdjustTwitterWidgetIframesId);
		return;
	}

	var rufousSandboxFound = false;
	var rufousSandboxChanged = false;
	$("iframe#rufous-sandbox").each(function(index) {
		rufousSandboxFound = true;
		/*
			This iframe should always be invisible so there's no need to convert the presentational
			attributes into style rules.
		 */
		var scrolling = $(this).attr("scrolling");
		var frameborder = $(this).attr("frameborder");
		if (typeof scrolling !== "undefined") {
			$(this).removeAttr("scrolling");
			rufousSandboxChanged = true;
		}
		if (typeof frameborder !== "undefined") {
			$(this).removeAttr("frameborder");
			rufousSandboxChanged = true;
		}
	});

	var twitterIframeFound = false;
	var twitterIframeChanged = false;
	$("iframe[src*=\"platform.twitter.com\"]").each(function(index) {
		twitterIframeFound = true;
		var title = $(this).attr("title");
		if (typeof title === "undefined" || title.trim() == "") {
			$(this).attr("title", "Twitter Widget Iframe");
			twitterIframeChanged = true;
		}
		/*
			If scrolling is "no" it is no longer removed by replaceScrollingAttributeInIframes.
			Remove it here to prevent accessibility findings of HTML used to format content.
		 */
		var scrolling = $(this).attr("scrolling");
		if (typeof scrolling !== "undefined" && scrolling == "no") {
			$(this).removeAttr("scrolling");
			twitterIframeChanged = true;
		}
	});

	if (rufousSandboxFound && !rufousSandboxChanged && twitterIframeFound && !twitterIframeChanged) {
		clearInterval(window.bgsuAdjustTwitterWidgetIframesId);
	}

}

function adjustTwitterWidgetIframes() {

	/*
		The Twitter widget platform sometimes generates iframes that, despite being invisible, are
		flagged as having accessibility issues due to having presentational attributes and lacking
		titles.  As the Twitter controls are generated asynchronously, wait until they are generated
		to repair the accessibility issues.
	 */

	if (typeof window.bgsuAdjustTwitterWidgetIframesId === "undefined" || window.bgsuAdjustTwitterWidgetIframesId == null) {
		window.bgsuAdjustTwitterWidgetIframesAttempts = 0;
		window.bgsuAdjustTwitterWidgetIframesId = setInterval(_adjustTwitterWidgetIframes, 125);
	}

}

function _adjustIframeSyncIframes() {

	window.bgsuAdjustIframeSyncIframesAttempts++;
	if (window.bgsuAdjustIframeSyncIframesAttempts > 50) {
		clearInterval(window.bgsuAdjustIframeSyncIframesId);
		return;
	}

	var uasIframeFound = false;
	var uasIframeChanged = false;
	$("div#iframeSync").find("iframe[src*=\"uas.bgsu.edu/admissions\"],iframe[src*=\"uas.bgsu.edu/frame\"]").each(function(index) {

		uasIframeFound = true;

		var title = $(this).attr("title");

		if (!(typeof title === "undefined" || title.trim() == "")) {
			return;
		}

		var src = $(this).attr("src");
		var lowerSrc = src.toLowerCase();

		for (var i = 0; i < window.bgsuAdjustIframeSyncIframeUpdates.length; i++) {
			var iframeUpdate = window.bgsuAdjustIframeSyncIframeUpdates[i];
			if (lowerSrc.indexOf(iframeUpdate.pattern) > -1) {
				$(this).attr("title", iframeUpdate.title);
				uasIframeChanged = true;
				return;
			}
		}

	});

	if (uasIframeFound && !uasIframeChanged) {
		clearInterval(window.bgsuAdjustIframeSyncIframesId);
	}

}

function adjustIframeSyncIframes() {

	/*
		The iframe sync used to read the Undergraduate Programs block from Admissions has its properties set
		by a remote script.  To work around this, wait for the iframe to be rendered and update its title.
	 */

	if (typeof window.bgsuAdjustIframeSyncIframesId === "undefined" || window.bgsuAdjustIframeSyncIframesId == null) {
		window.bgsuAdjustIframeSyncIframesAttempts = 0;
		window.bgsuAdjustIframeSyncIframesId = setInterval(_adjustIframeSyncIframes, 125);

		window.bgsuAdjustIframeSyncIframeUpdates = [
			{ pattern: "uas.bgsu.edu/admissions/academics/undergraduate-majors", title: "Undergraduate Majors and Programs" },
			{ pattern: "uas.bgsu.edu/admissions/academics/courses-offered", title: "Courses Offered" },
			{ pattern: "uas.bgsu.edu/admissions/scholarships-and-financial-aid/university-freshman-academic-scholarship-calculator", title: "Scholarship Calculator" },
			{ pattern: "uas.bgsu.edu/admissions/visit-bgsu/directions", title: "Directions to BGSU" },
			{ pattern: "uas.bgsu.edu/admissions/visit-bgsu/manage-your-visit", title: "Look Up Your Visit Information" },
			{ pattern: "uas.bgsu.edu/admissions/visit-bgsu/schedule-a-visit", title: "Schedule a Visit to BGSU - Select an Option" },
			{ pattern: "uas.bgsu.edu/admissions/visit-bgsu/class-visit-list", title: "Class Visit List Important Information" },
			{ pattern: "uas.bgsu.edu/admissions/visit-bgsu", title: "Visit BGSU" },
			{ pattern: "uas.bgsu.edu/admissions/contact-us/find-your-counselor", title: "Find Your Admissions Counselor - Select a State" },
			{ pattern: "uas.bgsu.edu/admissions/contact-us/office-directory", title: "Office of Admissions Directory" },
			{ pattern: "uas.bgsu.edu/admissions/contact-us", title: "Admissions Questions and Comments Form" },
			{ pattern: "uas.bgsu.edu/admissions/request-information/bgsu-firelands/transfer-students", title: "Admissions Information Request Form" },
			{ pattern: "uas.bgsu.edu/admissions/request-information/bgsu-firelands/freshmen", title: "Admissions Information Request Form" },
			{ pattern: "uas.bgsu.edu/admissions/request-information/freshmen", title: "Admissions Information Request Form" },
			{ pattern: "uas.bgsu.edu/admissions/request-information/transfer-students", title: "Admissions Information Request Form" },
			{ pattern: "uas.bgsu.edu/admissions/request-information/graduate-students", title: "Admissions Information Request Form" },
			{ pattern: "uas.bgsu.edu/admissions/apply-now/online-application", title: "Online Application" },
			{ pattern: "uas.bgsu.edu/admissions/next-steps", title: "Next Steps" },
			{ pattern: "uas.bgsu.edu/frame/admissions/scholarships-and-financial-aid/presidential-scholars-award", title: "BGSU Scholars Weekend" },
			{ pattern: "uas.bgsu.edu/frame/admissions/apply-now/online-application/advanced-high-school-programs", title: "College Credit Plus Program" },
			{ pattern: "uas.bgsu.edu/frame/musical-arts/junior-audition-day", title: "Junior Audition Day" },
			{ pattern: "uas.bgsu.edu/frame/musical-arts", title: "Musical Arts" },
			{ pattern: "uas.bgsu.edu/frame/school-counselors/security-access-request", title: "Security Access Request" },
			{ pattern: "uas.bgsu.edu/frame/school-counselors/counselor-day", title: "Counselor Days" },
			{ pattern: "uas.bgsu.edu/frame/school-counselors/enotification-request", title: "E-notification Request" },
			{ pattern: "uas.bgsu.edu/frame/school-counselors/applied-students", title: "Applied Students" },
			{ pattern: "uas.bgsu.edu/frame/school-counselors", title: "School Counselors" },
			{ pattern: "uas.bgsu.edu/frame/learning-commons/fly-program-application", title: "FLY Program Application" },
			{ pattern: "uas.bgsu.edu/frame/admissions/asset/postcard-campaign", title: "ASSET Postcard Campaign" },
			{ pattern: "uas.bgsu.edu/frame/admissions/asset/pass-it-on-registration", title: "ASSET Pass it on Registration" },
			{ pattern: "uas.bgsu.edu/frame/admissions/asset/asset-registration", title: "ASSET Registration" },
			{ pattern: "uas.bgsu.edu/frame/admissions/asset", title: "ASSET" },
			{ pattern: "uas.bgsu.edu/frame/admissions/events/receptions", title: "Receptions" },
			{ pattern: "uas.bgsu.edu/frame/admissions/apply-now/application-status", title: "Application Status" },
			{ pattern: "uas.bgsu.edu/frame/admissions/events", title: "Admissions Events" },
			{ pattern: "uas.bgsu.edu/frame/admissions", title: "Admissions" },
			/* Defaults and fallbacks are below.  They must be last in order. */
			{ pattern: "uas.bgsu.edu/frame", title: "Admissions" },
			{ pattern: "uas.bgsu.edu/admissions", title: "Admissions" },
		];
	}

}

function _adjustFloodlightIframes() {

	window.bgsuAdjustFloodlightIframesAttempts++;
	if (window.bgsuAdjustFloodlightIframesAttempts > 50) {
		clearInterval(window.bgsuAdjustFloodlightIframesId);
		return;
	}

	var floodlightsFound = false;
	var floodlightsChanged = false;
	$("iframe[src*=\"doubleclick.net\"]").each(function(index) {
		floodlightsFound = true;
		var title = $(this).attr("title");
		if (typeof title === "undefined" || title.trim() == "") {
			var srcAttribute = $(this).attr("src");
			/*
				In some cases the src attribute contains a src parameter, such as //######.fls.doubleclick.net/activityi;src=######;.
				For these, extract the ###### and include it in the title to help distinguish this iframe from others.
				For other cases, just apply a generic title.
			 */
			var srcParameterPosition = srcAttribute.indexOf("src=");
			if (srcParameterPosition > -1) {
				var nextSeparatorPosition = srcAttribute.indexOf(";", srcParameterPosition);
				var srcParameterValue = srcAttribute.substring(srcParameterPosition + 4,  /* 4 = length of "src=" */
					(nextSeparatorPosition == -1) ? srcAttribute.length : nextSeparatorPosition);
				$(this).attr("title", "Floodlight " + srcParameterValue);
				floodlightsChanged = true;
			}
			else {
				$(this).attr("title", "Floodlight");
				floodlightsChanged = true;
			}
		}
	});

	if (floodlightsFound && !floodlightsChanged) {
		clearInterval(window.bgsuAdjustFloodlightIframesId);
	}

}

function adjustFloodlightIframes() {

	/*
		The DoubleClick iframes in the Floodlight may not have titles and are specified through code blocks by
		content authors.  In case the author does not provide a title, derive a title from the src property
		in the query string on the iframe's src attribute.
	 */

	if (typeof window.bgsuAdjustFloodlightIframesId === "undefined" || window.bgsuAdjustFloodlightIframesId == null) {
		window.bgsuAdjustFloodlightIframesAttempts = 0;
		window.bgsuAdjustFloodlightIframesId = setInterval(_adjustFloodlightIframes, 125);
	}

}

function quietIframeSyncTypeErrors() {

	/*
		The iframeSync event handler for the "message" event refers to e.originalEvent.data.match, which may
		not be defined, resulting in a TypeError exception being thrown.  To prevent repeated errors being logged,
		place a handler earlier in the message event handler chain, and have this handler prevent the original
		handler from being executed if the exception would occur.

		An exception must be made for forms embedded from Slate by Technolutions.  The message must be allowed
		to propagate so that the response from Slate can replace the embedded form upon a successful submission.

		An additional exception must be made for the Ivy Chatbot by ivy.ai.
	 */

	$(window).preBind("message", function(e) {
		var originalEvent = e.originalEvent;
		var origin = originalEvent.origin;
		var data = originalEvent.data;
		if (typeof data.match === "undefined" && origin.indexOf("gradapply.bgsu.edu") == -1 && origin.indexOf("admissions.bgsu.edu") == -1 &&
			(typeof data.source === "undefined" || data.source !== "ivy.ai")) {
			e.stopImmediatePropagation();
			return false;
		}
	});

}

function ensureKeyControlsAreFirst() {

	var skipNav = $("div#skip-to-main-content");
	var quickContrastToggle = $("div#quick-contrast-toggle");

	if (skipNav && skipNav.length == 1) {

		if (!(skipNav.parent().is("body") && $("body:first-child").is(skipNav))) {
			skipNav.detach();
			$("body").prepend(skipNav);
		}

	}

	if (quickContrastToggle && quickContrastToggle.length == 1) {

		if (!skipNav.next().is(quickContrastToggle)) {
			quickContrastToggle.detach();
			skipNav.after(quickContrastToggle);
		}

	}

}

function _adjustSalesIqButtons() {

	window.bgsuAdjustSalesIqButtonsAttempts++;
	if (window.bgsuAdjustSalesIqButtonsAttempts > 50) {
		clearInterval(window.bgsuAdjustSalesIqButtonsId);
		return;
	}

	var chatButtonFound = false;
	var chatButtonChanged = false;
	$("div.zls-btnmn.zls-btrht").add("div.zsiq_floatmain").each(function(index) {
		chatButtonFound = true;
		var role = $(this).attr("role");
		if (typeof role === "undefined") {
			$(this).attr("role", "complementary");
			$(this).attr("aria-label", "Chat with eCampus");
			chatButtonChanged = true;
		}
	});

	if (chatButtonFound && !chatButtonChanged) {
		clearInterval(window.bgsuAdjustSalesIqButtonsId);
	}
	
}

function adjustSalesIqButtons() {

	if (typeof window.bgsuAdjustSalesIqButtonsId === "undefined" || window.bgsuAdjustSalesIqButtonsId == null) {
		window.bgsuAdjustSalesIqButtonsAttempts = 0;
		window.bgsuAdjustSalesIqButtonsId = setInterval(_adjustSalesIqButtons, 125);
	}

}

function _adjustSalesIqImages() {

	window.bgsuAdjustSalesIqImagesAttempts++;
	if (window.bgsuAdjustSalesIqImagesAttempts > 50) {
		clearInterval(window.bgsuAdjustSalesIqImagesId);
		return;
	}

	var chatImageFound = false;
	var chatImageChanged = false;
	$("div.zsiq_floatmain em.zsiq_user img[src*=\"gravatar.png\"]").each(function(index) {
		chatImageFound = true;
		var alt = $(this).attr("alt");
		if (typeof alt === "undefined") {
			$(this).attr("alt", "eCampus Logo Chat Button");
			chatImageChanged = true;
		}
	});

	if (chatImageFound && !chatImageChanged) {
		clearInterval(window.bgsuAdjustSalesIqImagesId);
	}

}

function adjustSalesIqImages() {

	if (typeof window.bgsuAdjustSalesIqImagesId === "undefined" || window.bgsuAdjustSalesIqImagesId == null) {
		window.bgsuAdjustSalesIqImagesAttempts = 0;
		window.bgsuAdjustSalesIqImagesId = setInterval(_adjustSalesIqImages, 125);
	}

}

function _adjustSalesIqIframes() {

	window.bgsuAdjustSalesIqIframesAttempts++;
	if (window.bgsuAdjustSalesIqIframesAttempts > 50) {
		clearInterval(window.bgsuAdjustSalesIqIframesId);
		return;
	}

	var iframeFound = false;
	var iframeChanged = false;
	$("iframe[src*=\"salesiq.zohopublic.com\"]").add("iframe[src*=\"salesiq.zoho.com\"]").each(function(index) {
		iframeFound = true;
		var title = $(this).attr("title");
		if (typeof title === "undefined" || title.trim() == "") {
			$(this).attr("title", "SalesIQ Widget Iframe");
			iframeChanged = true;
			replacePresentationAttributesInIframes($(this).parent());
		}
	});

	if (iframeFound && !iframeChanged) {
		clearInterval(window.bgsuAdjustSalesIqIframesId);
	}
	
}

function adjustSalesIqIframes() {

	if (typeof window.bgsuAdjustSalesIqIframesId === "undefined" || window.bgsuAdjustSalesIqIframesId == null) {
		window.bgsuAdjustSalesIqIframesAttempts = 0;
		window.bgsuAdjustSalesIqIframesId = setInterval(_adjustSalesIqIframes, 125);
	}

}

function adjustSalesIqControls() {

	adjustSalesIqButtons();
	adjustSalesIqImages();
	adjustSalesIqIframes();

}

function _adjustPureChatIframes() {

	window.bgsuAdjustPureChatIframesAttempts++;
	if (window.bgsuAdjustPureChatIframesAttempts > 50) {
		clearInterval(window.bgsuAdjustPureChatIframesId);
		return;
	}

	var iframeFound = false;
	var iframeChanged = false;
	$("iframe#purechat-frame").each(function(index) {
		iframeFound = true;
		var title = $(this).attr("title");
		if (typeof title === "undefined" || title.trim() == "") {
			$(this).attr("title", "Pure Chat Script Iframe");
			iframeChanged = true;
			replacePresentationAttributesInIframes($(this).parent());
		}
	});

	if (iframeFound && !iframeChanged) {
		clearInterval(window.bgsuAdjustPureChatIframesId);
	}
	
}

function adjustPureChatIframes() {

	if (typeof window.bgsuAdjustPureChatIframesId === "undefined" || window.bgsuAdjustPureChatIframesId == null) {
		window.bgsuAdjustPureChatIframesAttempts = 0;
		window.bgsuAdjustPureChatIframesId = setInterval(_adjustPureChatIframes, 125);
	}

}

function adjustPureChatControls() {

	adjustPureChatIframes();

}

function _adjustTintIframes() {

	window.bgsuAdjustTintIframesAttempts++;
	if (window.bgsuAdjustTintIframesAttempts > 50) {
		clearInterval(window.bgsuAdjustTintIframesId);
		return;
	}

	var iframeFound = false;
	var iframeChanged = false;
	$("iframe[src*=\"cdn.hypemarks.com\"]").each(function(index) {
		iframeFound = true;
		var title = $(this).attr("title");
		if (typeof title === "undefined" || title.trim() == "") {
			var src = $(this).attr("src");
			var newTitle = CQ.shared.String.endsWith(src, "raw/popUpModalEndpoint") ? "TINT Pop Up" : "TINT iframe";
			$(this).attr("title", newTitle);
			iframeChanged = true;
			replacePresentationAttributesInIframes($(this).parent());
		}
	});

	if (iframeFound && !iframeChanged) {
		clearInterval(window.bgsuAdjustTintIframesId);
	}
	
}

function adjustTintIframes() {

	if (typeof window.bgsuAdjustTintIframesId === "undefined" || window.bgsuAdjustTintIframesId == null) {
		window.bgsuAdjustTintIframesAttempts = 0;
		window.bgsuAdjustTintIframesId = setInterval(_adjustTintIframes, 125);
	}

}

function adjustTintControls() {

	adjustTintIframes();

}

$(function() {
	replacePresentationAttributesInIframes($(document));
	cleanWhitespaceOnlyTextElements();
	adjustTwitterWidgetIframes();
	adjustIframeSyncIframes();
	adjustFloodlightIframes();
	enhanceMegaMenuNavigation();
	quietIframeSyncTypeErrors();
	adjustSalesIqControls();
	adjustPureChatControls();
	adjustChatWithItsControls();
	adjustTintControls();
	modifyAccordionToggles();
	ensureKeyControlsAreFirst();
});
	
	
function modifyAccordionToggles() {

	$("[data-toggle=\"collapse\"]").each(function() {
		/*
			Bootstrap Collapse accordions have a class of "collapsed" when they are closed, but this is
			not applied when they start out closed.  To correct this, find cases in which the accordion
			toggle points to an accordion body that does not have the "in" class (which indicates the
			accordion is open), then manually apply the collapsed class.
		 */
		var $this = $(this);
		var target = $this.data("target");
		var href = $this.attr("href");
		if (target || href) {
			var collapsible = target ? $(target) : $(href);
			if (collapsible && collapsible.hasClass("accordion-body") && collapsible.hasClass("collapse") && !collapsible.hasClass("in")) {
				$this.addClass("collapsed");
			}
		}
		/*
			Add a container inside the accordion toggle to enable styling of the toggle title.
		 */
		var wrapper = $this.children(".accordion-wrapper");
		if (wrapper && wrapper.length == 0) {
			$this.wrapInner("<div class=\"accordion-wrapper\"></div>");
		}
	});

}

/*
	Adapted from https://gist.github.com/attila/5574857

	Bind a function to a jQuery event and force the new function to the top of the execution order
 */
$.fn.preBind = function(type, data, fn) {
	this.each(function() {
		var $this = $(this);

		$this.on(type, null, data, fn);

		var currentBindings = $._data($this[0], 'events');
		if (Array.isArray(currentBindings[type])) {
			currentBindings[type].unshift(currentBindings[type].pop());
		}
	});

	return this;
};

var BGSUSearch = BGSUSearch || {};

BGSUSearch = (function() {

	var searchImageInputSelector = "div[id^=___gcse] form.gsc-search-box table.gsc-search-box td.gsc-search-button button.gsc-search-button";
	var searchButtonInputClassName = "bgsu-gsc-search-button";
	var googleBrandingImageSelector =
		"div[id^=___gcse] img[class^=gsc-branding-img]," +
		"div[id^=___gcse] img[class*=\" gsc-branding-img\"]," +
		"div[id^=___gcse] img[class^=gcsc-branding-img]," +
		"div[id^=___gcse] img[class*=\" gcsc-branding-img\"]";
	var cseSelector = "div[id^=___gcse] div.gsc-control-cse";
	var loadingSelector = "div[id^=___gcse] div.gsc-loading-fade";
	var cursorControlSelector = "div[id^=___gcse] div.gsc-cursor-box div.gsc-cursor";
	var cursorControlPageSelector = cursorControlSelector + " div.gsc-cursor-page";
	var cursorControlCurrentPageSelector = cursorControlPageSelector + ".gsc-cursor-current-page";
	var resultInfoSelector = "div[id^=___gcse] div.gsc-result-info";
	var cursorPageClassName = "gsc-cursor-page";
	var cursorPageSelector = "div[id^=___gcse] ." + cursorPageClassName;
	var cursorBackClassName = "bgsu-gsc-cursor-back";
	var cursorBackSelector = "div[id^=___gcse] ." + cursorBackClassName;
	var cursorForwardClassName = "bgsu-gsc-cursor-forward";
	var cursorForwardSelector = "div[id^=___gcse] ." + cursorForwardClassName;
	var noResultsSelector = "div[id^=___gcse] .gs-no-results-result";
	var googleTableSelector =
		"div[id^=___gcse] table[class^=gsc]," +
		"div[id^=___gcse] table[class*=\" gsc\"]," +
		"table[class^=gstl_]," +
		"table[class*=\" gstl_\"]";
	var resultsRootSelector = "div[id^=___gcse] .gsc-resultsRoot";
	var adBlockSelector =
		"div[id^=___gcse] div.gsc-adBlockNoHeight";
	var searchBoxesSelector = "div[id^=___gcse] form.gsc-search-box";
	var searchBoxInputBoxSelector = "div[id^=___gcse] form.gsc-search-box div.gsc-input-box";
	var gscInputClassName = "gsc-input";
	var gscInputFocusClassName = "gsc-input-box-focus";
	var clearSearchSelector = "div[id^=___gcse] form.gsc-search-box table.gsc-search-box td.gsib_b div.gsst_b a.gsst_a";

	/*
		If the Previous or Next buttons are clicked, scan the page number buttons to
		determine which page is current, then trigger a click event on the appropriate
		page number button next to it.
	 */
	var _pageChange = function(offset) {
		var currentPageControl = $(cursorControlCurrentPageSelector);
		if (currentPageControl.length > 0) {
			var currentPage = parseInt(currentPageControl.html());
			if (!isNaN(currentPage)) {
				var targetPage = currentPage + offset;
				var targetPageControl = $(cursorControlPageSelector).filter(
					function(index) {
						return parseInt($(this).html()) === targetPage;
					}
				);
				if (targetPageControl.length > 0) {
					$(targetPageControl).trigger("click");
				}
			}
		}
	};

	var _pageForward = function() {
		_pageChange(1);
	};

	var _pageBack = function() {
		_pageChange(-1);
	};

	/*
		Replace the image-based search buttons with actual button elements.  These
		can be styled more easily for the high contrast mode.

		The "image" can be an actual button with an SVG element.
	 */
	var _replaceImageButtonsWithActualButtons = function() {
		$(searchImageInputSelector).each(function(index) {
			var searchImageInput = $(this);
			if (!searchImageInput.next().is("button." + searchButtonInputClassName)) {
				var searchButtonInput = $("<button />")
					.addClass("gsc-search-button")
					.addClass("gsc-search-button-v2")
					.addClass(searchButtonInputClassName)
					.attr("aria-label", "Search Button")
					.html("<span class=\"fas fa-search fa-flip-horizontal\" aria-hidden=\"true\"></span>");
				searchButtonInput.on("click", searchImageInput, function(event) {
					event.data.click();
					return false;
				});
				searchImageInput.after(searchButtonInput);
				searchImageInput.hide();
			}
		});
	};

	var _adjustClearSearchControls = function() {
		$(clearSearchSelector).each(function(index) {
			var clearSearchControl = $(this);
			var clearSearchControlRole = clearSearchControl.attr("role");
			if (typeof clearSearchControlRole === "undefined" || clearSearchControlRole == "") {
				clearSearchControl.attr("role", "button");
			}
			var clearSearchControlAriaLabel = clearSearchControl.attr("aria-label");
			if (typeof clearSearchControlAriaLabel === "undefined" || clearSearchControlAriaLabel == "") {
				clearSearchControl.attr("aria-label", "Clear search box");
			}
			var clearSearchControlText = clearSearchControl.children("span.gscb_a");
			if (clearSearchControlText && clearSearchControlText.length > 0) {
				clearSearchControlText.html("");
				clearSearchControlText.addClass("fas fa-times");
				clearSearchControlText.attr("aria-hidden", "true");
			}
		});
	};

	/*
		Replace bold tags surrounding found search terms in the results with strong tags.
	 */
	var _replaceBoldSearchTermsWithStrong = function() {
		$(resultsRootSelector).find("b").replaceWith(function() {
			return $("<strong>").append($(this).html());
		});
	};

	/*
		The iframe in the ad block has no title and has presentational attributes.
		Add a title and remove those attributes.  The iframe has no height since the
		university is registered with Google as an educational institution, so it
		is not necessary to replace the removed attributes with equivalent styles.
	 */
	var _cleanAdBlockIframe = function() {
		$(adBlockSelector).find("iframe").each(function(index) {
			var iframe = $(this);
			var title = iframe.attr("title");
			if (typeof title === "undefined" || title == "") {
				iframe.attr("title", "Ads by Google");
			}
			iframe.removeAttr("frameborder marginwidth marginheight allowtransparency scrolling width");
		});
	};

	/*
		Remove cellspacing and cellpadding attributes on tables created by Google CSE.
	 */
	var _fixPresentationalAttributesOnTables = function() {
		$(googleTableSelector).each(function(index) {
			var googleTable = $(this);
			var cellspacingAttr = googleTable.attr("cellspacing");
			if (typeof cellspacingAttr !== "undefined") {
				var cellspacing = parseInt(cellspacingAttr, 10);
				if (cellspacing == 0) {
					googleTable.css("borderSpacing", "0");
					googleTable.removeAttr("cellspacing");
				}
			}
			var cellpaddingAttr = googleTable.attr("cellpadding");
			if (typeof cellpaddingAttr !== "undefined") {
				var cellpadding = parseInt(cellpaddingAttr, 10);
				if (cellpadding == 0) {
					/*
						Even though cellpadding is an attribute on the table, to style the table properly each
						individual th and td would need to have their padding values set to the same value as
						cellpadding.  Because we are only looking for a cellpadding of 0 and many of the cells
						have their own padding that we do not want to override, we make no changes to the cells.
					 */
					googleTable.removeAttr("cellpadding");
				}
			}
		});
	};

	/* Apply boldface to the number of search results to make it resemble the current search */
	var _highlightResultCount = function() {
		var resultInfo = $(resultInfoSelector);
		if (resultInfo.length > 0) {
			var resultInfoContent = resultInfo.html();
			if (resultInfoContent.indexOf("About") == 0) {
				/* Format of string is "About N results (X.XX seconds)" */
				var resultInfoChunks = resultInfoContent.split(" ");
				/* Insert opening tag between "About" (index 0) and "N" (index 1) */
				resultInfoChunks.splice(1, 0, "<span class=\"count\">");
				/* Insert closing tag between "N" (now index 2) and "results" (now index 3) */
				resultInfoChunks.splice(3, 0, "</span>");
				var newResultInfoContent = resultInfoChunks.join(" ");
				resultInfo.html(newResultInfoContent);
			}
		}
	};

	/*
		Add Previous and Next buttons to pagination controls.
	 */
	var _addPaginationButtons = function() {
		var cursorControl = $(cursorControlSelector);
		if (cursorControl.length > 0) {
			var cursorBackControl = $(cursorBackSelector);
			if (cursorBackControl.length == 0) {
				var goBack = $("<div />")
					.addClass(cursorBackClassName)
					.addClass(cursorPageClassName)
					.attr("tabindex", "0")
					.attr("aria-label", "Previous Page")
					.attr("role", "link")
					.html("&laquo;");
				goBack.on("click", _pageBack);
				cursorControl.prepend(goBack);
			}
			var cursorForwardControl = $(cursorForwardSelector);
			if (cursorForwardControl.length == 0) {
				var goForward = $("<div />")
					.addClass(cursorForwardClassName)
					.addClass(cursorPageClassName)
					.attr("tabindex", "0")
					.attr("aria-label", "Next Page")
					.attr("role", "link")
					.html("&raquo;");
				goForward.on("click", _pageForward);
				cursorControl.append(goForward);
			}
		}
	};

	/*
		At the time of the original implementation the Google Custom Search would apply the class "gsc-input-box-focus"
		to the div.gsc-input-box that contains the search input box.  As of December 2018 this behavior appears to have
		been removed.

		We have custom style rules (see bgsu-gsc.css) that affect objects having this class, such as enabling the search
		box in the header search bar to expand when the input box receives focus.

		To work around this, we recreate the original behavior by applying the focus class to the container when the
		search input box receives focus and removing the class when the box loses focus.

 		We could change the style rule to use the pseudo-class :focus-within - allowing styling of an object when a
 		descendant has focus - but this is not supported in IE 11 and Microsoft Edge.
	 */
	var _addFocusClassToInputContainer = function(event) {
		var target = event.target;
		var inputContainerControl = $(target).parents(searchBoxInputBoxSelector);
		if (inputContainerControl.length > 0) {
			$(inputContainerControl).addClass(gscInputFocusClassName);
		}
	}

	var _removeFocusClassFromInputContainer = function(event) {
		var target = event.target;
		var inputContainerControl = $(target).parents(searchBoxInputBoxSelector);
		if (inputContainerControl.length > 0) {
			$(inputContainerControl).removeClass(gscInputFocusClassName);
		}
	}

	var _restoreFocusClassesOnContainer = function() {
		var searchBoxInputBoxControl = $(searchBoxInputBoxSelector);
		if (searchBoxInputBoxControl.length > 0) {
			var inputControl = $(searchBoxInputBoxControl).find("input." + gscInputClassName);
			if (inputControl.length > 0) {
				$(inputControl).on("focus", _addFocusClassToInputContainer);
				$(inputControl).on("blur", _removeFocusClassFromInputContainer);
			}
		}
	};

	var _customizeControls = function() {
		_replaceImageButtonsWithActualButtons();
		_adjustClearSearchControls();
		_fixPresentationalAttributesOnTables();
		_restoreFocusClassesOnContainer();

		if (typeof window.bgsuSearchBoxesToHide !== "undefined") {
			$(window.bgsuSearchBoxesToHide).fadeIn(400);
			window.bgsuSearchBoxesToHide = undefined;
		}
	}

	var _beforeSetupSearch = function() {
		/*
			Hide the search controls so any visual customizations are not visible until completed later.
		 */
		window.bgsuSearchBoxesToHide = $(searchBoxesSelector).filter(":visible");
		$(window.bgsuSearchBoxesToHide).hide();
	}

	var _setupSearch = function() {
		_customizeControls();
	};

	var _initializationHandler = function() {
		_beforeSetupSearch();
		if (document.readyState == 'complete') {
			_setupSearch();
		} else {
			google.setOnLoadCallback(_setupSearch, true);
		}
	};

	/*
		This is executed whenever a page of results is rendered.  The pagination and result count are
		regenerated with each page, so it is necessary to customize them with each navigation to a different
		page of the search results.

		The alternative is to set up a results ready handler function, but that would need to be responsible
		for rendering the results themselves.  To use Google's rendering with only slight modifications,
		it is better to let the Google engine render the results then modify them afterward.
	 */
	var _resultsRenderedHandler = function(gname, query, promoElts, resultElts) {
		_replaceBoldSearchTermsWithStrong();
		_cleanAdBlockIframe();
		_highlightResultCount();
		_addPaginationButtons();
	};

	return {
		initializationHandler: _initializationHandler,
		resultsRenderedHandler: _resultsRenderedHandler
	};

})();

window.BGSUSearch = BGSUSearch;

$(function () {
    function hideMobileSearchDropdownWhenStickMenuHidden() {
        if ($(window).scrollTop() <= 128 && $("div.mobile-search.mobile-search-dropdown.search-dropdown").hasClass("down")) {
            /*
               Remove the drop-down search bar that can appear in a small browser width if the user scrolls up to the
               point at which the "stick menu" would not appear, therefore causing the search button to be hidden.
             */
            $('div.mobile-search.mobile-search-dropdown.search-dropdown.down').hide().removeClass('down');
            $("a.mobile-search-nav").removeClass('active');
            $('.nav-space').removeClass('expanded');
        }
    }

    function adjustMobileSearchDropdownPlacement() {
        /*
           The mobile drop-down search bar appears directly below the stick menu if it is shown and directly below the
           large orange banner (with the BGSU logo, page title, search button, and menu button) if the stick menu is hidden.
         */
        var basisElement = "div.navigation.topnav div.nav-space" + ($(window).scrollTop() <= 128 ? "" : " div.nav-container");
        if ($(basisElement).length > 0) {
            var newTop = $(basisElement).offset().top + $(basisElement).height() - $(window).scrollTop();
            $("div.mobile-search.mobile-search-dropdown.search-dropdown").css("top", newTop);
        }
    }

	var hasBeenTrigged = false;
    $(window).on("scroll", function () {
        if ($(this).scrollTop() >= 121 && !hasBeenTrigged) { // if scroll is greater/equal then 100 and hasBeenTrigged is set to false.
            $('.sub-logo').css('width', '84');
            hasBeenTrigged = true;
        }
        if ($(this).scrollTop() <= 136 && hasBeenTrigged) { // if scroll is greater/equal then 100 and hasBeenTrigged is set to false.
            $('.sub-logo').css('width', '0');
            hasBeenTrigged = false;
        }
        
        hideMobileSearchDropdownWhenStickMenuHidden();
        adjustMobileSearchDropdownPlacement();
    });
    
    $(window).on("resize", function() {
    	hideMobileSearchDropdownWhenStickMenuHidden();
        adjustMobileSearchDropdownPlacement();
    });
    
    $(window).on("load", function() {
        adjustMobileSearchDropdownPlacement();
    });

	BGSUContrast.initialize({
		toggle: ".acc-contrast-switch",
		contrastOn: ".acc-contrast-on",
		contrastOff: ".acc-contrast-off"
	});

    // GENERAL FUNCTIONS           

    $(".container").fitVids();

    // HOME MENU FUNCTIONS         

    $('.top-home').on("click", function () {

        if ($(this).hasClass('clicked')) {
            $('#top .row').slideUp();

            $(this).removeClass('ss-closed').addClass('ss-home').html("");
            $(this).removeClass('clicked');
        }
        else {
            $('#top .row').slideDown();
            $(this).removeClass('ss-home').addClass('ss-close').html("close");
            $(this).addClass('clicked');
        }
    });

    // NAV FUNCTIONS    

    $(".navbar .nav > li").not('search-nav').find('a').on("click", function () {
        $('.dropdown-menu.search').slideUp();
        $('.search-dropdown').slideUp();
        $('.nav-space').removeClass('expanded');
    });
    $(".navbar").find('a.btn-navbar').on("click", function () {
        $('.dropdown-menu.search').slideUp();
        $('.search-dropdown').slideUp();
        $('.nav-space').removeClass('expanded');
    });
    $(".search-dropdown").hide();

    $("a.mobile-search-nav").on("click", function () {

        /*
           When the user clicks the magnifying glass in the small mobile device stick menu,
           open the mobile menu and activate the search item.
         */
    
        $("#main-nav a.btn-navbar[href='#mobile-nav']").trigger("click");
        $("#mobile-nav .search-nav-mobile input.search-bar").trigger("focus");

        return false;

    });

    $("#mobile-nav .search-nav-mobile input.search-bar").on("focus", function() {
    	$(this).parent().find("a.ss-icon").css({
    		"color": "white",
    		"background-color": "#ff7300"
    	});
    });

    $("#mobile-nav .search-nav-mobile input.search-bar").on("blur", function() {
    	$(this).parent().find("a.ss-icon").css({
    		"color": "#ff7300",
    		"background-color": "inherit"
    	});
    });

    $("li.search-nav a").on("click", function () {

        var search = $('.full-search-dropdown');

        if (search.hasClass('down')) {
            $('.down').slideUp().removeClass('down');
            $(this).removeClass('active');
        }
        else {
            $('.nav .active').removeClass('active');
            $('.down').slideUp().removeClass('down');
            $(this).addClass('active');
            search.slideDown({'complete': function () {
                    $('.nav-space').addClass('expanded');
                    $('#webSearch').trigger("focus");
                }}).addClass('down');
            $('#webSearch').trigger("focus");
        }

        return false;
    });

    $(".container").fitVids();


    $('#mobile-nav').css('height', '100%');


    $('.thumb-slider').flexslider({
        animation: "slide",
        controlNav: false
    });
	
	/*ONLY FIRE HOVERINTENT IF SCREEN IS LARGER THAN 969px -- to prevent double-tap issue on all mobile links*/
	if ( $(window).width() > 969) {  
	
	$("ul.nav li.dropdown").hoverIntent({
	        over: function () {
	            $(this).find("ul.dropdown-menu").fadeIn('fast');
	        },
	        out: function () {
	            $(this).find("ul.dropdown-menu").fadeOut('fast');
	        },
	        interval: '50'
	    });
	
	
	} 
	else {
	  //Add your javascript for small screens here 
	 $( "ul.nav li.dropdown").on("hover",
	  		function() {
	    		 $(this).find("ul.dropdown-menu").stop().fadeIn('fast');
	
	  	}, function() {
	    	$(this).find("ul.dropdown-menu").stop().fadeOut('fast');
	
	  	}
		);
	}

    $('.tertiary-slider').flexslider({
        animation: "slide",
        controlNav: false,
        start: function () {
            $('.bg, .carousel-caption').fadeTo("slow", 1);
        }
    });

    $('.news-carousel').flexslider({
        animation: "slide",
        itemWidth: 400,
        minItems: 3, // use function to pull in initial value
        maxItems: 3 // use function to pull in initial value
    });
    
    /*
        Remove lag between tap and click on mobile browsers to improve responsiveness and prevent
        interference with click logic.

    var attachFastClick = Origami.fastclick;
    attachFastClick(document.body);*/
    if(typeof FastClick != 'undefined'){
    	FastClick.attach(document.body);
    }

});